webpackJsonp([56],{

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1078);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("cfc377be", content, true);

/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.content-buttons[data-v-73597b6a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/opt/buildhome/repo/src/pages/configuration/page-dealers-implementers.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,sBAAyB,AACzB,uCAAwC,AACxC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,wCAAyC,AACzC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,0BAA6B,AAC7B,8CAA+C,AAC/C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,2CAA4C,AAC5C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,+CAAgD,AAChD,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,4CAA6C,AAC7C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,kCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC","file":"page-dealers-implementers.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_bold';\n  src: url(\"/static/fonts/Lato-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_light';\n  src: url(\"/static/fonts/Lato-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n.content-buttons[data-v-73597b6a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1079:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dealers-projects"},[_c('action-sidebar',{attrs:{"title":"Implementadores Asignados","value":true,"width":644},on:{"close-modal":_vm.closeModal}},[_c('app-table',{staticClass:"mt-5 is-not-selectable px-4",attrs:{"selectable":"","name":"implementers","selected-value":_vm.selectedValue,"check-all":_vm.checkAll,"columns":_vm.columns,"rows":_vm.implementers,"last-page":_vm.lastPage,"current-page":_vm.currentPage},on:{"on-selected-all":_vm.allIsSelected,"row-is-selected":_vm.rowIsSelected,"on-search-event":_vm.onSearchImplementers,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.email)+"\n\t\t\t")])]}}])}),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer content-buttons pt-3 pb-3"},[_c('v-btn',{staticClass:"btn-action caption mr-1",attrs:{"color":"pink"},on:{"click":_vm.closeModal}},[_vm._v("\n\t\t\t\tCancelar\n\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption ml-1",attrs:{"color":"success","disabled":_vm.disabledDeallocate},on:{"click":_vm.deallocatedRow}},[_vm._v("\n\t\t\t\tDesasignar\n\t\t\t")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_dealers_implementers_vue__ = __webpack_require__(854);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73597b6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dealers_implementers_vue__ = __webpack_require__(1079);
function injectStyle (ssrContext) {
  __webpack_require__(1077)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73597b6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_dealers_implementers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73597b6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dealers_implementers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function onSearch(value) {
	this.$emit('on-search', value);
}

function changePage(page) {
	this.$emit('change-page', page);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function allIsSelected(row) {
	this.$emit('all-is-selected', row);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'dealers-list',
	methods: {
		allIsSelected: allIsSelected,
		changePage: changePage,
		onSearch: onSearch,
		rowIsSelected: rowIsSelected
	},
	props: {
		rows: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		lastPage: {
			type: Number,
			default: 0
		},
		currentPage: {
			type: Number,
			default: 0
		},
		columns: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		checkAll: {
			type: Boolean,
			required: true
		},
		selectedValue: {
			type: String,
			required: true
		}
	}
});

/***/ }),

/***/ 744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_assign_vue__ = __webpack_require__(735);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba25164_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_assign_vue__ = __webpack_require__(745);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_assign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba25164_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_assign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 745:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-1"},[_c('app-table',{staticClass:"mt-3 is-not-selectable px-4",attrs:{"name":"dealers","selected-value":_vm.selectedValue,"check-all":_vm.checkAll,"columns":_vm.columns,"rows":_vm.rows,"current-page":_vm.currentPage,"last-page":_vm.lastPage,"selectable":""},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage,"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.allIsSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.codeProject)+"\n\t\t\t")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 854:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_configuration_table_assign__ = __webpack_require__(744);




var deallocatedRow = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var idSelected, body;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						idSelected = this.dataSelected.map(function (item) {
							return item.id;
						});
						body = {
							implementersIds: idSelected
						};
						_context.prev = 2;
						_context.next = 5;
						return this.$http.delete('distributaries/' + this.id + '/implementers', { data: body });

					case 5:
						this.showNotification('Los implementadores han sido desasignados');
						this.closeModal();
						this.listImplementers();
						_context.next = 13;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](2);

						this.showError();

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 10]]);
	}));

	return function deallocatedRow() {
		return _ref.apply(this, arguments);
	};
}();

var listImplementers = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						params = {
							page: this.params.page,
							search: this.params.search,
							perPage: 30
						};
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.get('distributaries/' + this.id + '/implementers', { params: params });

					case 4:
						response = _context2.sent;

						this.implementers = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context2.next = 12;
						break;

					case 9:
						_context2.prev = 9;
						_context2.t0 = _context2['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 9]]);
	}));

	return function listImplementers() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.listImplementers();
}

function disabledDeallocate() {
	return this.dataSelected.length < 1;
}

function rowIsSelected(row) {
	this.implementers = this.selectIsRow(this.implementers, this.selectedValue, row);
	this.checkAll = this.every(this.implementers, this.selectedValue);
	this.dataSelected = this.implementers.filter(function (r) {
		return r.flagSelected;
	});
}

function allIsSelected(checked) {
	var _this = this;

	this.checkAll = checked;
	this.dataSelected = [];
	this.implementers = this.implementers.map(function (item) {
		var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
		newRow.isSelected = checked;
		if (checked) {
			_this.dataSelected.push(item);
		}
		return newRow;
	});
	this.implementers = this.selectIsRow(this.implementers, this.selectedValue, false, checked);
}

function onSearchImplementers(search) {
	this.params.search = search ? search.trim() : null;
	this.listImplementers();
}

function closeModal() {
	this.goTo('page-config-dealers');
}

function changePage(page) {
	this.currentPage = page;
	this.listImplementers();
}

function data() {
	return {
		action: {
			search: ''
		},
		checkAll: false,
		currentPage: 1,
		columns: [{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true }, { id: 2, name: 'Correo', value: 'mail', checked: true, visible: true }],
		dataSelected: [],
		implementers: [],
		lastPage: 0,
		selectedValue: 'flagSelected',
		tabs: [{
			id: 1,
			name: 'Asignar'
		}, {
			id: 2,
			name: 'Asignados'
		}],
		tabsModel: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-dealers-implementers',
	created: created,
	data: data,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__["default"],
		tableAssign: __WEBPACK_IMPORTED_MODULE_4__components_configuration_table_assign__["a" /* default */]
	},
	computed: {
		disabledDeallocate: disabledDeallocate
	},
	methods: {
		allIsSelected: allIsSelected,
		closeModal: closeModal,
		changePage: changePage,
		deallocatedRow: deallocatedRow,
		listImplementers: listImplementers,
		rowIsSelected: rowIsSelected,
		onSearchImplementers: onSearchImplementers
	},
	props: {
		id: {
			type: [Number, String]
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/56.230f678318b2c2480971.js